<template>
  <div class="fair-survey-step fair-survey-step--welcome">
    <div class="fair-survey-step__head">
      <span class="fair-survey-step__eyebrow">Подбор подарка</span>
      <h1 class="fair-survey-step__title fair-survey-step__title--hero">
        {{ step.title }}
      </h1>
      <p class="fair-survey-step__subtitle">
        Несколько вопросов о получателе — и мы соберём подборку под повод,
        вкусы и бюджет. Займёт около трёх минут.
      </p>
    </div>

    <ul class="fair-survey-step__facts">
      <li
        v-for="fact in FACTS"
        :key="fact"
        class="fair-survey-step__fact"
      >
        {{ fact }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { GiftStep } from '@/features/gift/types/gift-config'

defineProps<{ step: GiftStep & { type: 'welcome' } }>()

const FACTS = [
  'Повод и кто получатель',
  'Интересы, любимые бренды и стили',
  'Бюджет — подборка уложится в него',
]
</script>

<style scoped>
.fair-survey-step--welcome {
  justify-content: center;
  gap: var(--fair-rd-space-40);
}

.fair-survey-step__title--hero {
  font-size: 44px;
  line-height: 1.05;
}

:global(.fair-survey-dialog--compact) .fair-survey-step__title--hero {
  font-size: 28px;
}

.fair-survey-step__facts {
  display: flex;
  flex-direction: column;
  gap: var(--fair-rd-space-12);
  margin: 0;
  padding: 0;
  list-style: none;
}

.fair-survey-step__fact {
  padding-block: var(--fair-rd-space-12);
  border-top: 1px solid var(--fair-rd-line-hairline);
  font-family: var(--fair-font-body, Inter, sans-serif);
  font-size: 15px;
  line-height: 1.3;
  color: var(--fair-rd-text-secondary);
}

.fair-survey-step__fact:last-child {
  border-bottom: 1px solid var(--fair-rd-line-hairline);
}
</style>
